import type {FC} from 'react';
import type {SanityImage} from '@selvklart/sanity-next-image';

import type {ImageWeb} from '@/modules/foundation/components/image/types';
import {imageFromSanityImage} from '@/modules/foundation/sanity/image/query';
import {PortableText} from '@/modules/foundation/sanity/portable-text';

import {
	ArticlePage,
	articlePageContentPortableTextOverrides,
	articlePageLeadPortableTextOverrides,
} from '../../components/article-page';

import type {ArticleBySlugQueryResult} from './query';

interface Props {
	article: ArticleBySlugQueryResult;
}

export const ArticlePageContainer: FC<Props> = ({article}) => {
	const {heading, content, lead, _createdAt, image, _updatedAt} = article ?? {};

	let imageWeb: ImageWeb | undefined = undefined;

	if (image?.asset?._ref) {
		const img = imageFromSanityImage(image as SanityImage, 5 / 3);
		imageWeb = {
			image: img,
			altText: image.altText,
		};
	}

	return (
		<ArticlePage
			lead={
				lead && (
					<PortableText
						blocks={lead}
						overrideClassNames={articlePageLeadPortableTextOverrides}
					/>
				)
			}
			content={
				content && (
					<PortableText
						blocks={content}
						overrideClassNames={articlePageContentPortableTextOverrides}
					/>
				)
			}
			heading={heading}
			createdAt={_createdAt}
			imageWeb={imageWeb}
			updatedAt={_updatedAt}
		/>
	);
};
